const getWeekDays = (date) => {
    const days = [];
    let day = date;

    for (let i = 0; i < 7; ++i) {
        days.push(day);
        day = day.clone().add(1, 'd');
    }

    return days;
};

export default getWeekDays;
